import { Candle } from '@starx/shared-types';

// Keeps ticks received during an HTTP history request from being overwritten
// by its older snapshot. A buffer belongs to exactly one symbol/timeframe.
export class CandleHistoryBuffer {
  revision = 0;
  private streamed = new Map<number, { candle: Candle; revision: number }>();

  clear() { this.streamed.clear(); this.revision = 0; }

  record(candle: Candle) {
    this.streamed.set(candle.time, { candle: { ...candle }, revision: ++this.revision });
    while (this.streamed.size > 500) this.streamed.delete(this.streamed.keys().next().value!);
  }

  merge(history: Candle[], requestedAt: number): Candle[] {
    const merged = new Map(history.map(c => [c.time, { ...c }]));
    const historyEnd = Math.max(-Infinity, ...history.map(c => c.time));
    for (const { candle: live, revision } of this.streamed.values()) {
      // Closed history remains authoritative unless newer ticks arrived while
      // it was in flight. Preserve the streaming tail across replica lag.
      if (live.time < historyEnd && revision <= requestedAt) continue;
      const old = merged.get(live.time);
      merged.set(live.time, old && !(old as Candle & { simulated?: boolean }).simulated ? {
        ...old, high: Math.max(old.high, live.high), low: Math.min(old.low, live.low),
        close: live.close, volume: Math.max(old.volume, live.volume),
      } : { ...live });
    }
    return [...merged.values()].sort((a, b) => a.time - b.time).slice(-500);
  }
}
